import { Fragment, useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";

const PracticalExamQuestion = ({ isExpired, input, changeHandler }) => {
    const storyBoardTitle = input && input.storyBoardTitle;
    const storyBoardInfo = input && input.storyBoardInfo;
    const taskTitle = input && input.taskTitle;
    const taskInfo = input && input.taskInfo;
    const editorRef = useRef("");
    const [answer, setAnswer] = useState();
    const [answerIsValid, setAnswerIsValid] = useState(true);

    useEffect(() => {
        if (input) {
            setAnswer(input.answer);
        }
    }, [input]);

    return (
        <Fragment>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>{storyBoardTitle}</label>
                <div>{storyBoardInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>{taskTitle}</label>
                <div>{taskInfo}</div>
            </div>
            <hr />
            <div className="d-flex flex-column pb-2">
                <label className="pb-2" style={{ color: '#0F75BC' }}>Answer</label>
                <div>
                    <Editor
                        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
                        onInit={(evt, editor) => (editorRef.current = editor)}
                        value={answer}
                        licenseKey={"gpl"}
                        disabled={isExpired}
                        onEditorChange={(e) => {
                            setAnswerIsValid(true);
                            if (!e) {
                                setAnswerIsValid(false);
                            }
                            setAnswer(e);
                            changeHandler(input.id, e);
                        }}
                        init={{
                            height: 500,
                            menubar: false,
                            plugins: [
                                "advlist",
                                "autolink",
                                "lists",
                                "link",
                                "image",
                                "charmap",
                                "anchor",
                                "searchreplace",
                                "visualblocks",
                                "code",
                                "fullscreen",
                                "insertdatetime",
                                "media",
                                "table",
                                "preview",
                                "help",
                                "wordcount",
                            ],
                            toolbar:
                                "fontfamily fontsize bold italic underline strikethrough backcolor forecolor h1 h2 hr alignleft aligncenter " +
                                "alignright alignjustify bullist numlist outdent indent link image blockquote subscript superscript removeformat help",
                            content_style: "body { font-family: 'Trebuchet MS'; backgroud-color: #f9f9f9 }",
                        }}
                    />
                    {!answerIsValid && <p className="error">Please provide answer</p>}</div>
            </div>
            <hr />
        </Fragment>
    );
};

export default PracticalExamQuestion;
